module.exports = __webpack_public_path__ + "img/keyboard.9610f54a.svg";